import { FormattedMessage } from "react-intl";
import React from "react";
import role from "../../../../../../config/App-role";

export const selectOpts = [
  // TODO: 暫時不開放 admin, editor
  // {
  //   role: role.admin,
  //   value: role.admin,
  //   label: (
  //     <FormattedMessage
  //       id="sna.sidebar.grouptool.role.admin"
  //       defaultMessage="管理者"
  //     />
  //   ),
  // },
  {
    role: role.editor,
    value: role.editor,
    label: (
      <FormattedMessage
        id="sna.sidebar.grouptool.role.editor"
        defaultMessage="編輯者"
      />
    ),
  },
  {
    role: role.reader,
    value: role.reader,
    label: (
      <FormattedMessage
        id="sna.sidebar.grouptool.role.reader"
        defaultMessage="訪客"
      />
    ),
  },
];
